//= Functions & Modules
// Own
import { NotificationsSystem } from '../components/NotificationsSystem';

export function getNotificationsSystem(): NotificationsSystem {
    return window.g_notificationsSystem;
}
